"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verticals = void 0;
var verticals = ['truck', 'care', 'logistics-scheduler', 'service-gastro'];
exports.verticals = verticals;